<template>
  <section>
    <div class="align">
      <div id="pkBgFon"></div>
      <div>
        <h1>Как быстро<br/>
          получить займ?</h1>
        <ul>
          <li>
            <div>1</div>
            <p>
              Вы
              <a href="#">оставляете заявку</a>
               на сайте или звоните<br/> нам по телефону
              <a href="tel:88006009990" class="phone">
                <IconBase :viewBox="'0 0 16 16'">
                  <telephone></telephone>
                </IconBase>
                <span>8 800 600 99 90</span>
              </a>
            </p>
          </li>
          <li>
            <div>2</div>
            <p>Ваша заявка рассматривается нашей системой</p>
          </li>
          <li>
            <div>3</div>
            <p>В случае одобрения Вам звонит менеджер и договаривается
              об удобном времени получения денег</p>
          </li>
          <li>
            <div>4</div>
            <p>Наш агент оформит все документы у Вас дома</p>
          </li>
          <li>
            <div>5</div>
            <p>В течение дня деньги поступят на Ваш банковский счет</p>
          </li>
        </ul>
      </div>
      <div>
        <button class="svgMoney" v-on:click.prevent="scrTo">
          <IconBase :viewBox="'0 0 24 24'">
            <IconPayments></IconPayments>
          </IconBase>
          <span>Получить деньги</span>
          <IconBase :viewBox="'0 0 16 16'">
            <IconPayments></IconPayments>
          </IconBase>
        </button>
      </div>

    </div>

  </section>
</template>

<script>
  export default {
    name: "fast",
    components: {
      IconBase: () => import('@/components/svg/IconBase'),
      IconPayments: () => import('@/components/svg/payments-finance-36'),
      telephone: () => import('@/components/svg/phone-call'),
    },
    methods:{
      scrTo(){
        this.$parent.$children.forEach(item => {
          if (item.$refs.formAlign != undefined) {
            window.scrollTo({
              left:0,
              top:item.$refs.formAlign.offsetTop,
              behavior: 'smooth'
            });
          }
        });
      }
    }
  }
</script>

<style scoped>
  section {background: radial-gradient(circle at 50%, #186952, #0D5A44);color: white;padding: 14vw 0 4.7vw;}
  #pkBgFon{display: none;}
  ul {}
  ul > li {display: flex;align-items: center;justify-content: space-between;margin: 6vw 0;}
  ul > li > div {background: #42AB34;border-radius: 100%;width: 10vw;height: 10vw;display: flex;align-items: center;justify-content: center;font-size: 5vw;
    font-weight: bold;}
  ul > li > p {width: calc(100% - 15vw);font-size: 5.6vw;}
  ul > li > p > a {color: #42AB34;}
  ul > li > p > a.phone {color: white;font-weight: bold;text-decoration: none;display: inline-block}
  ul > li > p > a.phone > svg {width: 4.6vw;height: 4.6vw;margin: 0.1vw 2vw 0 0;}


  @media screen and (min-width: 760px) {
    section {padding: 4vw 0 1.3vw;position: relative}

    section .align{display: flex;align-items: flex-end;justify-content: space-between;position: relative}
    section .align > div{width: 50%;}
    section .align > div:nth-child(3){text-align: right}
    section .align > div:nth-child(3) button{width: 23.7vw;margin: 0 7.7vw 0 0;}
    #pkBgFon{position: absolute;top:-4vw;right: 0;width: 51.2vw;height: 28.6vw;background-image:
      url('../../assets/images/bgMoneyTiny.png');display: block;background-size: cover;}
    ul {}
    ul > li {margin: 2.2vw 0;}
    ul > li > div {width: 2.8vw;height: 2.8vw;font-size: 1.4vw;}
    ul > li > p {font-size: 1.6vw;width: calc(100% - 4.6vw);}
    ul > li > p > a {cursor: pointer}
    ul > li > p > a.phone {}
    ul > li > p > a.phone > svg {width: 1.3vw;height: 1.3vw;margin: 0.1vw 0.6vw 0 0;}
    ul > li > p > a.phone > span {}
  }
  @media screen and (min-width: 1140px) {
    section {padding: 45px 0 15px;}
    #pkBgFon{top:-45px;width: 583px;height: 326px;}
    ul {}
    ul > li {margin: 25px 0;}
    ul > li > div {width: 32px;height: 32px;font-size: 16px;}
    ul > li > p {font-size: 18px;width: calc(100% - 47px);}
    ul > li > p > a {}
    ul > li > p > a.phone {}
    ul > li > p > a.phone > svg {width: 15px;height: 15px;margin: 1px 5px 0  0;}
    ul > li > p > a.phone > span {}
    section .align > div:last-child button{width: 270px;margin: 0 100px 0 0;}
  }
</style>
